import React, {useState, useEffect, Fragment} from 'react';
import 'fontsource-roboto';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useIsMountedRef from '../Components/useIsMountedRef';
import useForceUpdate from '../Components/useForceUpdate';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {Link as UrlLink} from '@material-ui/core';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import Checkbox from '@material-ui/core/Checkbox';
import Fab from '@material-ui/core/Fab';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import SearchIcon from '@material-ui/icons/Search';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import BlockIcon from '@material-ui/icons/Block';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import DeleteIcon from '@material-ui/icons/Delete';
import RestoreFromTrashIcon from '@material-ui/icons/RestoreFromTrash';
import AddIcon from '@material-ui/icons/Add';
import NewReleasesIcon from '@material-ui/icons/NewReleases';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(1, 0)
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  listItemDense: {
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  listItemIcon: {
    minWidth: theme.spacing(5)
  },
  listItemTextDense: {
    marginTop: '0px',
    marginBottom: '0px'
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide {...props} direction='up' />;
});

const defaultFilter = {
  idPartner: '0',
  text: '',
  showExtendedInfo: false,
  showDeletedItems: false,
  // the following properties are used to filter services in partnerServices interface
  serviceCategory: '',
  service: ''
};

export default function Partners(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const filterServiceRef = React.createRef();

  const isMountedRef = useIsMountedRef();
  const forceUpdate = useForceUpdate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState(defaultFilter);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemOperation, setSelectedItemOperation] = useState(null);
  const [selectedItemWarning, setSelectedItemWarning] = useState(null);
  const [selectedItemCheckedOptions, setSelectedItemCheckedOptions] = useState([]);
  const [selectedItemSubitems, setSelectedItemSubitems] = useState([]);

  const fullScreen = useMediaQuery(useTheme().breakpoints.down('xs'));

  useEffect(() => {
    setIsLoaded(false);
    ajax('getPartners')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data);

        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    if (filter.serviceCategory === '')
      return;

    const timer = setTimeout(() => {
      filterServiceRef.current.focus();
    }, 1);
    return () => clearTimeout(timer);
  }, [filter.serviceCategory, filterServiceRef]);

  const handleSelectedItemChange = e => {
    setSelectedItem({
      ...selectedItem,
      [e.target.name]: e.target.type === 'checkbox' ? (e.target.checked ? '1' : '0') : e.target.value !== null ? e.target.value : ''
    });
  };

  useEffect(() => {
    setSelectedItemCheckedOptions([]);
    setSelectedItemSubitems([]);

    if (selectedItem === null || selectedItemOperation === null)
      return;

    var warning = null;
    switch (selectedItemOperation) {
      case 'editPartner':
        warning = warning === null ? selectedItem.partner.length < 6 ? 'Numele partenerului este prea scurt' : null : warning;
        break;

      case 'partnerServices':
        // setSelectedItemCheckedOptions(data.userPermissions.filter(userPermission => userPermission.idUser === selectedItem.id && userPermission.checked === '1').map(userPermission => userPermission.idPermission));
        break;

      case 'partnerCnasLimits':
        setSelectedItemSubitems(data.cnasLimits.filter(item => item.idPartner = selectedItem.id));
        break;

      default:
        break;
    }

    setSelectedItemWarning(warning);
  }, [data, selectedItem, selectedItemOperation]);

  const handleItemCheckedOptionsToggle = value => () => {
    const currentIndex = selectedItemCheckedOptions.indexOf(value);
    const newChecked = [...selectedItemCheckedOptions];

    if (currentIndex === -1)
      newChecked.push(value);
    else
      newChecked.splice(currentIndex, 1);

    setSelectedItemCheckedOptions(newChecked);

    filterServiceRef.current.focus();
  };

  const filterData = item => true
      && !!~item.partner.toLowerCase().indexOf(filter.text.toLowerCase())
      && ((!filter.showDeletedItems && item.deletedBy === null) || (filter.showDeletedItems && item.deletedBy !== null));

  const handleItemMenuOpen = item => e => {
    setSelectedItem(item);
    setAnchorEl(e.currentTarget);
  };
  const handleItemMenuClick = operation => () => {
    setAnchorEl(null);
    setSelectedItemOperation(operation);
  };
  const handleItemMenuClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
    setSelectedItemOperation(null);
  };

  const handleItemSubitemAdd = () => {
    let tmpSelectedItemSubitems = selectedItemSubitems;
    tmpSelectedItemSubitems.push({
      id: '',
      year: '',
      month: '',
      cnasLimit: selectedItem.defaultCnasLimit
    });
    setSelectedItemSubitems(tmpSelectedItemSubitems);
    forceUpdate();
  };

  const handleSelectedItemSubitemChange = index => e => {
    let tmpSelectedItemSubitems = selectedItemSubitems;
    tmpSelectedItemSubitems[index][e.target.name] = e.target.value;
    setSelectedItemSubitems(tmpSelectedItemSubitems);
    forceUpdate();
  };

  const handleItemSubitemDelete = i => {
    let tmpSelectedItemSubitems = selectedItemSubitems;
    tmpSelectedItemSubitems.splice(i, 1);
    setSelectedItemSubitems(tmpSelectedItemSubitems);
    forceUpdate();
  };

  const handleEditPartner = () => {
    setIsLoaded(false);
    ajax('savePartner', selectedItem)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleSavePartnerServices = () => {
    setIsLoaded(false);
    ajax('savePartnerServices', selectedItem)
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleSavePartnerCnasLimits = () => {
    setIsLoaded(false);
    ajax('resellerSavePartnerCnasLimits', {
      idPartner: selectedItem.id,
      defaultCnasLimit: selectedItem.defaultCnasLimit,
      cnasLimits: selectedItemSubitems
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleDeletePartner = () => {
    setIsLoaded(false);
    ajax('markPartnerAsDeleted', {
      idPartner: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  const handleUndeletePartner = () => {
    setIsLoaded(false);
    ajax('markPartnerAsUndeleted', {
      idPartner: selectedItem.id
    })
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok) {
          handleItemMenuClose();
          setData(response.data);
        }

        setIsLoaded(true);
      });
  };

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Parteneri</Typography>
      <Typography variant='subtitle2'>Administrare parteneri.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.partners.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.partners.length > 0 &&
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showExtendedInfo'
                  checked={filter.showExtendedInfo}
                  value={filter.showExtendedInfo}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza informatii extinse'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch color='primary'
                  name='showDeletedItems'
                  checked={filter.showDeletedItems}
                  value={filter.showDeletedItems}
                  onChange={handleFilterChange}
                />
              }
              label='Afiseaza partenerii stersi'
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.partners.length > 0 && data.partners.filter(filterData).length === 0 &&
        <Box>
          <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
          <Typography color='primary' align='center'>Daca v-ati pierdut, incercati resetarea filtrelor de <UrlLink href='#' color='initial' onClick={() => setFilter(defaultFilter)}>aici</UrlLink></Typography>
        </Box>
      }

      {isLoaded &&
        <List dense>
          {data.partners.filter(filterData).map((item, i, a) =>
            <Fragment key={item.id}>
              {(i === 0 || a[i].isPriceCategory !== a[i - 1].isPriceCategory) &&
                <ListSubheader color='primary' disableSticky>{Boolean(parseInt(item.isPriceCategory)) ? 'Categorii de pret' : 'Entitati juridice'}</ListSubheader>
              }

              <ListItem dense button className={classes.listItemDense}
                selected={selectedItem && item.id === selectedItem.id}
                onClick={() => {
                  setSelectedItem(item);
                  setSelectedItemOperation('editPartner');
                }}
              >
                <ListItemIcon>
                  {Boolean(parseInt(item.isDefault)) &&
                    <CheckCircleOutlineIcon color='primary' />
                  }
                  {!Boolean(parseInt(item.isEnabled)) &&
                    <BlockIcon color='secondary' />
                  }
                </ListItemIcon>
                <ListItemText className={classes.listItemTextDense} disableTypography
                  primary={
                    <Typography style={{fontWeight: 'bold'}}>{item.partner}</Typography>
                  }
                  secondary={
                    <Box>
                      <Typography component='span' display='block' color='textSecondary'>
                        Companie asociata din SmartLabs:
                        <Typography display='inline' color='textPrimary'>{` ${item.companySL}`}</Typography>
                      </Typography>
                      {Boolean(+item.defaultCnasLimit) &&
                        <Typography component='span' display='block' color='primary'>
                          Limita lunara implicita de trimiteri prin CAS:
                          <Typography display='inline' color='secondary'>{` ${item.defaultCnasLimit}`}</Typography>
                        </Typography>
                      }
                      {!Boolean(parseInt(item.isEnabled)) &&
                        <Typography variant='caption' component='span' display='block' color='error'>Acest partener este dezactivat</Typography>
                      }
                      {filter.showExtendedInfo &&
                        <Box>
                          {!Boolean(parseInt(item.isPriceCategory)) &&
                            <Box>
                              <Typography color='textSecondary'>
                                {`Adresa: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.address}</Typography>
                              </Typography>
                              <Typography color='textSecondary'>
                                {`Registrul comertului: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.registerNumber}</Typography>
                              </Typography>
                              <Typography color='textSecondary'>
                                {`CUI: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.taxCode}</Typography>
                              </Typography>
                              <Typography color='textSecondary'>
                                {`Telefon: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.phone}</Typography>
                              </Typography>
                              <Typography color='textSecondary'>
                                {`Email: `}
                                <Typography component='span' display='inline' color='textPrimary'>{item.mail}</Typography>
                              </Typography>
                            </Box>
                          }
                          <Typography color='textSecondary'>
                            {`Creat de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdBy}</Typography>
                            {` la data de `}
                            <Typography component='span' display='inline' color='textPrimary'>{item.createdAt}</Typography>
                          </Typography>
                        </Box>
                      }
                      {item.deletedBy &&
                        <Typography color='secondary'>{`Sters de ${item.deletedBy} la data de ${item.deletedAt}`}</Typography>
                      }
                      <Typography variant='caption' color='textSecondary' display='block' style={{fontStyle: 'italic', whiteSpace: 'pre-wrap'}}>{item.description}</Typography>
                    </Box>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge='end'
                    onClick={handleItemMenuOpen(item)}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            </Fragment>
          )}
        </List>
      }

      <Menu keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleItemMenuClose}
      >
        <MenuItem divider={false} onClick={handleItemMenuClick('editPartner')}>
          <ListItemIcon className={classes.listItemIcon}><EditIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1' style={{fontWeight: 'bold'}}>Modifica</Typography>
        </MenuItem>

        <MenuItem divider={false} onClick={handleItemMenuClick('partnerServices')}>
          <ListItemIcon className={classes.listItemIcon}><LocalHospitalIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1'>Servicii contractate</Typography>
        </MenuItem>

        <MenuItem divider={false} onClick={handleItemMenuClick('partnerCnasLimits')}>
          <ListItemIcon className={classes.listItemIcon}><CardGiftcardIcon fontSize='small' /></ListItemIcon>
          <Typography variant='body1'>Parteneriate CAS</Typography>
        </MenuItem>

        {selectedItem && !selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('deletePartner')}>
            <ListItemIcon className={classes.listItemIcon}><DeleteIcon fontSize='small' color='secondary' /></ListItemIcon>
            <Typography variant='body1' color='secondary'>Sterge</Typography>
          </MenuItem>
        }

        {selectedItem && selectedItem.deletedBy &&
          <MenuItem divider={false} onClick={handleItemMenuClick('undeletePartner')}>
            <ListItemIcon className={classes.listItemIcon}><RestoreFromTrashIcon fontSize='small' color='primary' /></ListItemIcon>
            <Typography variant='body1' color='primary'>Anuleaza stergerea</Typography>
          </MenuItem>
        }
      </Menu>

      {isLoaded &&
        <Fab variant='extended' className={classes.fab}
          onClick={() => {
            setSelectedItem({
              id: '',
              partner: '',
              isPriceCategory: '0',
              registerNumber: '',
              taxCode: '',
              bankAccount: '',
              bank: '',
              contactPerson: '',
              phone: '',
              email: '',
              address: '',
              idCompanySL: '',
              description: ''
            });
            setSelectedItemOperation('editPartner');
          }}
        >
          <AddIcon className={classes.fabIcon} />
          Adauga partener
        </Fab>
      }

      {selectedItem && selectedItemOperation === 'editPartner' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'editPartner'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>{selectedItem.name ? selectedItem.name : 'Adaugare partener nou'}</DialogTitle>
          <DialogContent>
            <DialogContentText component='div'>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={7}>
                  <TextField margin='none' required autoComplete='off'
                    label='Nume partener'
                    placeholder='Nume partener'
                    name='partner'
                    value={selectedItem.partner}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <RadioGroup
                    name='isPriceCategory'
                    value={selectedItem.isPriceCategory}
                    onChange={handleSelectedItemChange}
                  >
                    <FormControlLabel value='0' control={<Radio size='small' color='primary' style={{padding: '2px 8px'}} />} label='Este entitate juridica' />
                    <FormControlLabel value='1' control={<Radio size='small' color='primary' style={{padding: '2px 8px'}} />} label='Este categorie de pret' />
                  </RadioGroup>
                </Grid>
                {!Boolean(parseInt(selectedItem.isPriceCategory)) &&
                  <Fragment>
                    <Grid item xs={6}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Registrul comertului'
                        placeholder='Registrul comertului'
                        name='registerNumber'
                        value={selectedItem.registerNumber}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='CUI'
                        placeholder='CUI'
                        name='taxCode'
                        value={selectedItem.taxCode}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Cont bancar'
                        placeholder='Cont bancar'
                        name='bankAccount'
                        value={selectedItem.bankAccount}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Banca'
                        placeholder='Banca'
                        name='bank'
                        value={selectedItem.bank}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Persoana de contact'
                        placeholder='Persoana de contact'
                        name='contactPerson'
                        value={selectedItem.contactPerson}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Telefon'
                        placeholder='Telefon'
                        name='phone'
                        value={selectedItem.phone}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Email'
                        placeholder='Email'
                        name='email'
                        value={selectedItem.email}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField margin='none' required autoComplete='off'
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Adresa'
                        placeholder='Adresa'
                        name='address'
                        value={selectedItem.address}
                        onChange={handleSelectedItemChange}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField margin='none' required select
                        disabled={Boolean(parseInt(selectedItem.isPriceCategory))}
                        label='Companie asociata din SmartLabs'
                        placeholder='Companie asociata din SmartLabs'
                        name='idCompanySL'
                        value={selectedItem.idCompanySL}
                        onChange={handleSelectedItemChange}
                      >
                        <MenuItem key='0' value='0'>Nici un partener</MenuItem>
                        {data.companiesSL.map(option => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.companySL}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Fragment>
                }
                <Grid item xs={12}>
                  <TextField margin='none' multiline rows={3}
                    label='Observatii'
                    placeholder='Observatii'
                    name='description'
                    value={selectedItem.description}
                    onChange={handleSelectedItemChange}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <Divider className={classes.divider} />
            <Warning display='block' style={{visibility: selectedItemWarning ? 'visible' : 'hidden'}}>{selectedItemWarning}</Warning>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded || Boolean(selectedItemWarning)} color='primary' onClick={handleEditPartner}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'partnerServices' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted fullWidth
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'partnerServices'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Servicii contractate - {selectedItem.partner}</DialogTitle>
          <DialogContent>
            <Typography color='secondary'>De aici alegem un pachet existent pentru vizualizare sau pentru modificare, sau, definim un pachet nou</Typography>
            <Card>
              <CardHeader style={{padding: '8px 16px'}}
                avatar={<Avatar><SearchIcon /></Avatar>}
                title={
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <TextField margin='none' select
                        label='Categorie servicii'
                        placeholder='Categorie servicii'
                        name='serviceCategory'
                        value={filter.serviceCategory}
                        onChange={handleFilterChange}
                      >
                        {[...new Set(data.services.map(service => service.serviceCategory))].map(option => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField margin='none' inputRef={filterServiceRef}
                        label='Nume serviciu'
                        placeholder='Nume serviciu'
                        name='service'
                        value={filter.service}
                        onChange={handleFilterChange}
                        onFocus={e => e.target.select()}
                      />
                    </Grid>
                  </Grid>
                }
                subtitle={
                  Boolean(selectedItemCheckedOptions)
                    ? <Typography color='primary'>{selectedItemCheckedOptions.length} servicii selectate</Typography>
                    : <Typography color='secondary'>Selectati cel putin un serviciu</Typography>
                }
              />
              <Divider />
              <List dense style={{height: '430px', overflow: 'auto'}}>
                {filter.serviceCategory === ''
                  ? <Warning align='center'>Selectati o categorie de servicii din lista de mai sus</Warning>
                  : data.services
                      .filter(service => !!~selectedItemCheckedOptions.indexOf(service.id) || (service.serviceCategory === filter.serviceCategory && !!~service.service.toLowerCase().indexOf(filter.service.toLowerCase())))
                      .sort(service => !!~selectedItemCheckedOptions.indexOf(service.id) ? -1 : 1)
                      .map(item =>
                          <ListItem key={`${item.idService}_${item.idServiceSL}`} dense button divider={false} className={classes.listItemDense}
                            onClick={handleItemCheckedOptionsToggle(item.id)}
                          >
                            <ListItemIcon>
                              <Checkbox size='small' disableRipple edge='start' tabIndex={-1} color='primary'
                                checked={selectedItemCheckedOptions.indexOf(item.id) !== -1}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={item.service}
                              secondary={!!~selectedItemCheckedOptions.indexOf(item.id) ? item.serviceCategory : ''}
                            />
                          </ListItem>
                    )
                }
              </List>
            </Card>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleSavePartnerServices}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'partnerCnasLimits' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          fullScreen={fullScreen}
          open={Boolean(selectedItem) && selectedItemOperation === 'partnerCnasLimits'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Parteneriate CAS - {selectedItem.partner}</DialogTitle>
          <DialogContent>
            <TextField margin='none' required autoComplete='off'
              label='Limita lunara implicita de trimiteri prin CAS'
              placeholder='Limita lunara implicita de trimiteri prin CAS'
              name='defaultCnasLimit'
              value={selectedItem.defaultCnasLimit}
              onChange={handleSelectedItemChange}
            />
            <List dense>
              {selectedItemSubitems.map((item, i) =>
                <ListItem key={i} dense disableGutters className={classes.listItemDense}>
                  <ListItemText className={classes.listItemTextDense} disableTypography
                    primary={
                      <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <TextField margin='none' required select
                            label='An'
                            placeholder='An'
                            name='year'
                            value={selectedItemSubitems[i].year}
                            onChange={handleSelectedItemSubitemChange(i)}
                            >
                              {[new Date().getFullYear(), new Date().getFullYear() + 1].map(option => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={5}>
                          <TextField margin='none' required select
                            label='Luna'
                            placeholder='Luna'
                            name='month'
                            value={selectedItemSubitems[i].month}
                            onChange={handleSelectedItemSubitemChange(i)}
                          >
                            {['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'].map((option, index) => (
                              <MenuItem key={index} value={index + 1}>
                                {option}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={3}>
                          <TextField margin='none' required autoComplete='off'
                            label='Limita'
                            placeholder='Limita'
                            name='cnasLimit'
                            value={selectedItemSubitems[i].cnasLimit}
                            onChange={handleSelectedItemSubitemChange(i)}
                          />
                        </Grid>
                      </Grid>
                    }
                  />
                  <ListItemSecondaryAction>
                    <IconButton edge='end'
                      onClick={() => handleItemSubitemDelete(i)}
                    >
                      <DeleteIcon color='secondary' />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              )}
            </List>
            {Boolean(+selectedItem.defaultCnasLimit)
              ? <Button onClick={handleItemSubitemAdd}>
                  Adauga o limita noua
                </Button>
              : <Warning>Nu puteti defini o limita lunara de trimiteri daca nu aveti definita o limita implicita!</Warning>
            }
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleSavePartnerCnasLimits}>
              Salveaza
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'deletePartner' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'deletePartner'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Marcati acest partener ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe STERGE doar daca sunteti sigur ca doriti sa stergeti acest partener.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='secondary' onClick={handleDeletePartner}>
              Sterge
            </Button>
          </DialogActions>
        </Dialog>
      }

      {selectedItem && selectedItemOperation === 'undeletePartner' &&
        <Dialog disableBackdropClick={!isLoaded} disableEscapeKeyDown={!isLoaded} keepMounted
          open={Boolean(selectedItem) && selectedItemOperation === 'undeletePartner'}
          TransitionComponent={Transition}
          onClose={handleItemMenuClose}
        >
          <DialogTitle>Anulati marcarea acestui partener ca sters?</DialogTitle>
          <DialogContent>
            <DialogContentText><Typography component='span'>Apasati pe DA doar daca sunteti sigur ca doriti sa anulati stergerea acestui partener.</Typography></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button disabled={!isLoaded} autoFocus onClick={handleItemMenuClose}>
              Anuleaza
            </Button>
            <Button disabled={!isLoaded} color='primary' onClick={handleUndeletePartner}>
              DA
            </Button>
          </DialogActions>
        </Dialog>
      }
    </Container>
  );
}